module.exports = __webpack_public_path__ + "static/new-york-091bb95c54992ffe8c5dd4710479d8b5.png";